import { createFileRoute } from "@tanstack/react-router"

import WorkInProgressAlert from "@/components/common/Alerts/WorkInProgressAlert"

export const Route = createFileRoute("/app/admin/")({
  component: AdminRouteComponent,
})

function AdminRouteComponent() {
  return <WorkInProgressAlert />
}
